import { countUpCounter } from '../utils/countup.js'

const statsBlockInit = () => {
    const stats = [...document.querySelectorAll('.js-key-stat')]
    stats.forEach((stat) => countUpCounter(stat))
}
statsBlockInit()
